import React, { useEffect, useState } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import DatePicker from 'react-datepicker';
import Select from 'react-select';
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment/moment';

import { FormData } from '../../../helpers/FormData';
import { _campaignSMSReport, _campaignsGet, _getTimeZones, } from '../../../services/apiConnections.service';

export const CampaignSmsReport = () => {

    const [smsReport, setSmsReport] = useState([]);
    const [emptyTable, setEmptyTable] = useState(false);
    const [token, setToken] = useState(null);
    const [error, setError] = useState(null);

    const [maxStartTime, setMaxStartTime] = useState(new Date());
    const [maxEndTime, setMaxEndTime] = useState(new Date());
    const [timeZones, setTimeZones] = useState([]);
    const [campaigns, setCampaigns] = useState([]);
    // eslint-disable-next-line no-unused-vars
    const [filterValues, handleFilterValueChange, setFilterValues] = FormData({
        campaigns: [],
        time_zone: {
            label: 'Europe/Sofia',
            value: 472
        },
        date_from: new Date(
            new Date(
                new Date().setHours(
                    new Date().getHours() - 1
                )
            ).setMinutes(0)
        ),
        date_to: new Date()
    });

    let startOfTheDay = new Date(new Date().setHours(0)).setMinutes(0);
    let browserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    useEffect(() => {
        if (!token) {
            setToken(localStorage.getItem('token'));
        }
        if (token && !smsReport.length && !emptyTable) {
            handleFilter();
        }
    }, [token, smsReport, emptyTable]);

    useEffect(() => {
        if (token) {
            handleCampaigns();
            handleTimeZones();
        }
    }, [token])

    useEffect(() => {
        if (token) {
            handleFilter();
        }
    }, [filterValues]);

    useEffect(() => {
        let now = new Date();
        if (filterValues.date_from.getDate() < now.getDate()) {
            setMaxStartTime(new Date(new Date().setHours(23)).setMinutes(59));
        } else {
            setMaxStartTime(new Date());
        }
        if (filterValues.date_from > filterValues.date_to) {
            handleFilterValueChange('date_to', filterValues.date_from);
        }
    }, [filterValues.date_from]);

    useEffect(() => {
        let now = new Date();
        if (filterValues.date_to.getDate() < now.getDate()) {
            setMaxEndTime(new Date(new Date().setHours(23)).setMinutes(59));
        } else {
            setMaxEndTime(new Date());
        }
    }, [filterValues.date_to]);

    const handleCampaigns = async () => {
        let result = await _campaignsGet(token);
        if (result.error) {
            console.log("error");
            setError(result.error);
        } else {
            let arr = result.campaigns.filter((e) => { return e.status !== 0 });
            arr = arr.map((e) => {
                return {
                    label: e.name,
                    value: e.ID
                }
            });
            setCampaigns(arr);
        }
    };

    const handleTimeZones = async () => {
        let result = await _getTimeZones(token);
        let arr = result.time_zones.map((e) => {
            return {
                label: e.name,
                value: result.time_zones.indexOf(e)
            }
        });
        setTimeZones(arr);
    };

    useEffect(() => {
        if (timeZones.length) {
            let currentTimeZone = timeZones.find((e) => e.label === browserTimeZone);
            if (JSON.stringify(filterValues.time_zone) !== JSON.stringify(currentTimeZone)) handleFilterValueChange('time_zone', currentTimeZone);
        }
    }, [timeZones]);

    const handleFilter = () => {
        let campaignsIds = [];
        if (filterValues.campaigns.length) {
            for (let e of filterValues.campaigns) {
                campaignsIds.push(e.value);
            }
        }
        let searchObj = {
            campaigns: campaignsIds.length ? campaignsIds : null,
            time_zone: filterValues.time_zone.label || null,
            date_from: dateToLocalISO(filterValues.date_from) || null,
            date_to: dateToLocalISO(filterValues.date_to) || null
        }
        let search = `limit=500`;
        for (let e in searchObj) {
            if (searchObj[e] != null) {
                search += `&${e}=${searchObj[e]}`;
            }
        }
        getData(token, search);
    };

    const getData = async (token, search = '') => {
        let result = await _campaignSMSReport(token, search);
        if (result.error) {
            console.log("--error:", result.error);
        } else {
            console.log("--result:", result.stats);
            setEmptyTable(result.stats == null);
            setSmsReport(result.stats == null ? [] : result.stats);
        }
        setError(result.error);
    };

    const dateToLocalISO = (date) => {
        let timeZoneOffset = (new Date(date)).getTimezoneOffset() * 60000;
        let localISOTime = (new Date(date - timeZoneOffset)).toISOString();
        return localISOTime;
    };

    const dateColumnFormatter = (cell, row) => {
        return (
            <span>{moment(new Date(cell)).format('yyyy-MM-DD H:mm')}</span>
        );
    };

    const statusColumnFormatter = (cell, row) => {
        return (
            <span>{cell == 0 ? 'In Progress' : 'Finished'}</span>
        );
    };

    const columns = [
        {
            dataField: 'start_at',
            text: 'Start Time',
            sort: true,
            formatter: dateColumnFormatter
        },
        {
            dataField: 'name',
            text: 'Campaign',
            sort: true
        },
        {
            dataField: 'recipients_count',
            text: 'Recipients'
        },
        {
            dataField: 'messages_sent',
            text: 'Sent SMS'
        },
        {
            dataField: 'successful_attempts',
            text: 'Successfully Sent SMS'
        },
        {
            dataField: 'status',
            text: 'Status',
            sort: true,
            formatter: statusColumnFormatter
        }
    ];

    const defaultSorted = [
        {
            dataField: 'start_at',
            order: 'desc'
        }
    ];

    const customTotal = (from, to, size) => (
        <span className="react-bootstrap-table-pagination-total"> Showing {from} to {to} of {size} Results</span>
    );

    const paginatorOptions = {
        hidePageListOnlyOnePage: true,
        showTotal: true,
        paginationTotalRenderer: customTotal,
        sizePerPageList: [
            {
                text: '50', value: 50
            },
            {
                text: '100', value: 100
            },
            {
                text: '200', value: 200
            },
            {
                text: '500', value: 500
            }
        ]
    };

    const noData = () => {
        return <p className='emptyTableMessage'>No matching records found</p>
    };

    return (
        <div className='content wideContent'>
            <div>
                <div className='pageTitle'>
                    <span>Campaign SMS Report</span>
                </div>
                {error && <p className='msgBlock errorMsg'>{error}</p>}
                <div className='row'>
                    <div className='col-lg-12'>
                        <div className='myTable'>
                            <div className='tableHeader'>
                                <div className='dateTimePickerBlock'>
                                    <div className='col-6'>
                                        <label className='inputLabel'>From</label>
                                        <DatePicker
                                            selected={filterValues.date_from}
                                            onChange={(date) => {
                                                handleFilterValueChange(
                                                    'date_from',
                                                    new Date(date));
                                            }}
                                            selectsStart
                                            showTimeSelect
                                            dateFormat="yyyy-MM-dd H:mm"
                                            timeFormat='H:mm'
                                            maxDate={new Date()}
                                            minTime={startOfTheDay}
                                            maxTime={maxStartTime}
                                            className='formInput datePicker'
                                        />
                                    </div>
                                    <div className='col-6'>
                                        <label className='inputLabel'>To</label>
                                        <DatePicker
                                            selected={filterValues.date_to}
                                            onChange={(date) => {
                                                handleFilterValueChange(
                                                    'date_to',
                                                    new Date(date));
                                            }}
                                            selectsEnd
                                            showTimeSelect
                                            dateFormat="yyyy-MM-dd H:mm"
                                            timeFormat='H:mm'
                                            minDate={filterValues.date_from}
                                            maxDate={new Date()}
                                            minTime={filterValues.date_from.getDate() < filterValues.date_to.getDate() ?
                                                startOfTheDay :
                                                filterValues.date_from
                                            }
                                            maxTime={maxEndTime}
                                            className='formInput datePicker'
                                        />
                                    </div>
                                </div>
                                <div className="mb-3">
                                    <Select
                                        id='timeZones'
                                        name='timeZones'
                                        className='customSelect'
                                        classNamePrefix='select'
                                        options={timeZones}
                                        value={filterValues.time_zone}
                                        onChange={(selectedOption) => handleFilterValueChange(
                                            'time_zone',
                                            selectedOption
                                        )}
                                    />
                                </div>
                                <div className="mb-3">
                                    <label
                                        className='inputLabel'
                                        htmlFor='campaign'>Campaign</label>
                                    <Select
                                        id='campaign'
                                        name='campaign'
                                        className='customSelect'
                                        classNamePrefix='select'
                                        options={campaigns}
                                        placeholder='Select campaigns'
                                        value={filterValues.campaigns}
                                        isMulti
                                        isOptionDisabled={() => filterValues.campaigns.length > 9}
                                        onChange={(selectedOption) => handleFilterValueChange(
                                            'campaigns',
                                            selectedOption
                                        )} />
                                </div>
                            </div>
                            <BootstrapTable
                                keyField='id'
                                data={smsReport}
                                columns={columns}
                                wrapperClasses='table-responsive'
                                bordered={false}
                                pagination={paginationFactory(paginatorOptions)}
                                defaultSorted={defaultSorted}
                                noDataIndication={noData} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}